export const drawerSize = {
    default: 360,
    sm: 360,
    md: 480,
    lg: 600,
    extended: '95vw',
    full: '100vw',
}
